import React, { useEffect } from "react";
import "./AboutUs.css";
import { Link } from "react-router-dom";
import MainPageTestimonials from "../../Container/Home/MainPageTestimonials";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="error-message">
      <div>
        <img src="/about1.jpg" alt="" />
      </div>
      <div className="container mx-auto py-4 px-4 sm:px-6 md:px-8">
        <div className="my-5 mt-10 flex flex-col gap-5 md:gap-10">
          {/* About Us Section */}
          <section>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              About Us
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                At the heart of Fina Interior lies a commitment to excellence. We
                believe that the home is a sacred space, and every piece of furniture
                and interior accessory should reflect the essence of the homeowner's
                personality and style. With this belief, we curate a diverse and
                exquisite collection that caters to various tastes, preferences, and
                lifestyles.
              </p>
            </div>
          </section>

          {/* Interior Design and Furniture Products */}
          <section>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Interior Design and Furniture Products
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                Founded by Tausif Khan, Fina Interior is dedicated to the art of
                interior design and furniture products. With a passion for creating
                beautiful, functional spaces, Tausif has built a brand that embodies
                creativity, innovation, and a commitment to enhancing living
                environments. Our core focus is on delivering tailored design
                solutions to meet the unique needs of our clients.
              </p>
            </div>
          </section>

          {/* Curated Furniture Collection */}
          <section>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Our Curated Furniture Collection
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                Fina Interior offers a carefully curated collection of furniture
                products that seamlessly complement our designs. Each piece is
                selected to blend style and functionality, helping clients create
                their ideal living or working space.
              </p>
            </div>
          </section>

          {/* Affordable Pricing */}
          <section>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Affordable Pricing
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                We pride ourselves on offering competitive pricing that is 40% to 60%
                more affordable than other interior firms. Our dedicated in-house
                execution team ensures high-quality results without compromising on
                craftsmanship or design.
              </p>
            </div>
          </section>

          {/* Commitment to Sustainability */}
          <section>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Commitment to Sustainability
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                Fina Interior is committed to sustainable and eco-friendly design
                practices. We source materials responsibly and incorporate
                energy-efficient elements to align with modern trends in green
                interior design.
              </p>
            </div>
          </section>

          {/* Vision and Future */}
          <section>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Vision and Future
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                Tausif Khan and Nargis Khan's vision is to continue evolving as a
                leading force in interior design and furniture. With exceptional
                customer service and a portfolio of stunning projects, we aim to
                inspire and enrich lives.
              </p>
            </div>
          </section>

          {/* Co-Founders */}
          <section className="py-10">
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide mb-10"
            >
              Meet the Visionaries: Our Co-Founders
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 text-center">
              <div>
                <h1 className="text-2xl font-semibold">Tausif Khan</h1>
                <p className="mt-2 text-lg text-gray-700">Co-Founder</p>
              </div>
              <div>
                <h1 className="text-2xl font-semibold">Nargis Khan</h1>
                <p className="mt-2 text-lg text-gray-700">Co-Founder</p>
              </div>
            </div>
          </section>
          <div>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Our Team
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                Our dedicated team transforms ideas into reality. With a diverse group of professionals, Fina
                Interior is here to help you create spaces that are not only visually appealing but also functional and
                environmentally sustainable.
              </p>
            </div>
          </div>
          {/* <div className="w-full flex justify-center">
            <img src="/team.png" className=" rounded-3xl shadow-2xl" />
          </div> */}
          <div>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Thank You for Choosing Fina Interior Interior Company
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                At Fina Interior, we are passionate about transforming spaces into environments that inspire,
                relax, and elevate your daily life. Whether it's a home, office, or commercial space, our goal is to
                create designs that resonate with your unique style and meet your funconal needs.

              </p>
            </div>
          </div>
          <div>
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Why Choose Fina Interior?
            </h1>
            <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                Tailored Design Soluons: Every space is different, and we take pride in offering personalized
                designs that reflect your taste and personality.<br></br><br></br>
                Premium Quality: We offer only the finest materials and crasmanship, ensuring that every piece
                of furniture and every design detail stands the test of me.<br></br><br></br>
                Sustainability Focus: We integrate eco-friendly and sustainable design pracces, making sure our
                work contributes to a greener future.<br></br><br></br>
                End-to-End Service: From concept to compleon, we manage every step of the process with
                precision, care, and dedicaon to customer sasfacon.<br></br><br></br>
                We Value Your Trust<br></br><br></br>
                Your trust and sasfacon drive us to connue innovang and delivering the best in interior
                design and furniture soluons. We look forward to being a part of your journey as we bring your
                vision to life.
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2">
            <p className="text-lg font-semibold text-gray-700">
              Instagram: <a href="https://instagram.com/FinaInterior" className="text-blue-500"> @finainterior</a>
            </p>
            <p className="text-lg font-semibold text-gray-700">
              Facebook: <a href="https://facebook.com/FinaInterior" className="text-blue-500"> @finainterior</a>
            </p>
            <p className="text-lg font-semibold text-gray-700">
              Website: <a href="https://www.finainterior.com" className="text-blue-500"> www.finainterior.com</a>
            </p>
          </div>
          {/* Footer */}
          <footer className="mt-10">
            <h1
              align="center"
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-wide"
            >
              Visit Us Our Factory Address
            </h1>
            <div className="flex flex-col items-center">
              <p className="mt-5 text-center text-lg font-semibold text-gray-700">
                Opposite to Margosa Heights Apt.,<br></br>
                Mohammadwadi, Hadapsar, Pune, <br></br>
                Maharashtra 411028.<br></br>
                Contact: (+91) 91128 81916
              </p>
            </div>
          </footer>
          <div className="flex justify-center">
              <p className="mt-5  tracking-wider text-lg font-semibold text-gray-700 text-justify">
                Thank you for letting Fina Interior be a part of your journey in creating
                beautiful and functional spaces. We look forward to serving you again!
              </p>
            </div>
        </div>
      </div>

    </div>
  );
};

export default AboutUs;
